import { useState } from 'react'
import { client } from '@lib/api'
import * as Sentry from '@sentry/react'

export type PlnCustomerDetails = {
  name: string
  segment_power: string
  meter_no: string
  subscriber_id: string
}

export type PlnInquiryResponse = {
  customer_no: string
  is_valid: boolean
  provider_rc: string
  provider_message: string
  customer: PlnCustomerDetails | null
}

export const usePlnInquiry = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const inquireCustomer = async (customerNo: string): Promise<PlnInquiryResponse | null> => {
    setIsLoading(true)
    setIsError(false)
    setError(null)

    try {
      const response = await client.doPost<PlnInquiryResponse>('/wallet/ppob/pln/inquiry', {
        customer_no: customerNo
      })

      setIsLoading(false)
      return response
    } catch (err: any) {
      setIsError(true)
      setIsLoading(false)
      setError(err.responseBody?.error?.message || err.message || 'Failed to inquire PLN customer')
      Sentry.captureException(err, {
        tags: { feature: 'ppob', service: 'pln-inquiry' },
        extra: { customerNo }
      })
      return null
    }
  }

  return {
    isLoading,
    isError,
    error,
    inquireCustomer
  }
}
